module.exports = __webpack_public_path__ + "img/oil_injection.dd9e96cc.png";